import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    editable: {},
  }),
  { name: 'ReadonlyHtmlEditor' }
);
